import { REDUCER_NAME } from './constants'

const getInstance = (state, ID: string) => state[REDUCER_NAME][ID] || {}
const getData = (state, ID: string) => getInstance(state, ID).data || {}
const getUI = (state, ID: string) => getInstance(state, ID).ui || {}

export const isInstanceCreated = (state, ID) => state[REDUCER_NAME][ID]

export const getShowCurrentGraphic = (state, ID: string) => getUI(state, ID).showCurrentGraphic
export const getCurrentGraphic = (state, ID: string) => getData(state, ID).currentGraphic
export const getOldGraphicByRestrDate = (state, ID: string, restrDate: string) => restrDate && getData(state, ID).oldGraphic[restrDate]
export const getActiveOldGraphicRestrDate = (state, ID: string) => getData(state, ID).activeOldGraphicRestrDate
export const getLoadingStatus = (state, ID: string) => getUI(state, ID).loading
